import type { NotificationActivities } from '~/types/Notification'

export default function useNotificationApi() {
	const getActivities = async <T = PaginationContext<NotificationActivities[]>>(query?: Record<string, unknown>) => {
		const { data } = await useAPI<IRequestResponse<T>>(`/activities?${createQueryParam(query || {})}`)
		return data.value
	}
	const getTodoList = async <T = NotificationTodo>(query?: object) => {
		const { data } = await useAPI<IRequestResponse<T>>('/todos', { query })
		// The idea of not query is so that it won't save when we are in the purchase/:purchase id route cause it needs to fetch a new re ord based on just that purchase and hence has no reason to be in the store
		if (data.value?.data && !query) {
			const { setTodoRecords } = useStore()

			const records = data.value.data as unknown as NotificationTodo[]
			setTodoRecords(records)
		}
		return data.value
	}
	return {
		getActivities,
		getTodoList
	}
}
